import Modal from "../../General/ConfirmableModal";
import { useState } from "react";
import { Box, TextField, Button, CircularProgress } from "@mui/material";

type NotesModalProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (notes: string, isApproved: boolean) => void;
  isApproved: boolean;
};

const NotesModal = ({
  open,
  onClose,
  onSubmit,
  isApproved,
}: NotesModalProps) => {
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      onSubmit(notes, isApproved);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          maxWidth: "100%",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          border: "2px solid #000",
          boxShadow: 24,
          p: 4,
        }}
      >
        <h2>{isApproved === true ? "Approve Request" : "Decline Request"}</h2>
        <TextField
          label="Notes"
          fullWidth
          multiline
          rows={4}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        <Box
          mt={2}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Submit"}
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NotesModal;
